import { z } from 'zod';

/**
 * シリアル：バリデーション
 */
export const SERIAL_VALIDATE = {
  LENGTH: {
    MIN: 22, // 最小文字数
    MAX: 25, // 最大文字数
  } as const,
} as const;

/**
 * シリアルコードの形式を検証する正規表現
 */
export const SERIAL_VALIDATE_REGEX =
  /^[A-Z]{5}(-[0-9]{4}){4}$|^[A-Z]{5}-[-0-9]{16}$/;

/**
 * バリデーションメッセージ
 */
export const SERIAL_VALIDATE_MESSAGES = {
  LENGTH: 'コードは22文字以上、25文字以内で入力してください',
  FORMAT: 'コードの形式が不正です',
} as const;

/**
 * バリデーション定義
 */
export const SERIAL_FORM_SCHEMA = z.object({
  serial: z
    .string()
    .min(SERIAL_VALIDATE.LENGTH.MIN, SERIAL_VALIDATE_MESSAGES.LENGTH)
    .max(SERIAL_VALIDATE.LENGTH.MAX, SERIAL_VALIDATE_MESSAGES.LENGTH)
    .regex(SERIAL_VALIDATE_REGEX, {
      message: SERIAL_VALIDATE_MESSAGES.FORMAT,
    }),
});
export type SerialForm = z.infer<typeof SERIAL_FORM_SCHEMA>;

/**
 * シリアル認証状態
 */
export const SERIAL_STATUS = {
  // 何もしていない
  NONE: 'NONE',
  // エラー
  ERROR: 'ERROR',
  // シリアルと利用サービスが不一致
  NOT_SERVICE_MATCH: 'NOT_SERVICE_MATCH',
  // 成功
  SUCCESS: 'SUCCESS',
};
export type SerialStatusType =
  (typeof SERIAL_STATUS)[keyof typeof SERIAL_STATUS];

/**
 * シリアルエラーメッセージ
 */
export const SerialErrorMessageMap: { [key in SerialStatusType]: string } = {
  [SERIAL_STATUS.NONE]: '',
  [SERIAL_STATUS.ERROR]: '認証に失敗しました。コードを再入力してください。',
  [SERIAL_STATUS.NOT_SERVICE_MATCH]:
    '認証に失敗しました。ポケトークIDでログインしてください。',
  [SERIAL_STATUS.SUCCESS]: '',
};
